import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.monitoring.head'),
        url: RouteEntity.Monitoring,
        objName: [PrivilegesModules.ValmanMonitoring],
    },
];

export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {};
